import classNames from 'classnames';
import { FC, ReactElement, memo } from 'react';
import { Icons } from '~/assets/fonts/Icons/icons';
import { isLocalHost } from '~/constants/main';
import theme from '~/constants/styles';
import Icon from '~/view/components/Controls/Icon/Icon';

const Zoho: FC = (): ReactElement | null => {
  const openZoho = () => {
    if (typeof window.ZohoHCAsap?.Action === 'function') window.ZohoHCAsap.Action('open');
  };

  if (window.IS_MOBILE) return null;

  return (
    <div className={classNames({ 'cursor-pointer': !isLocalHost })}>
      <Icon name={Icons.Chat} size={22} color={theme.colors.gray2} onPress={openZoho} />
    </div>
  );
};

export default memo(Zoho);
